import React from "react";
import { handleCheckout } from "../api/BackendApi";

const CheckoutButton = ({ amount, fileId, isTemporary, disabled = false }) => {
  return (
    <button 
      disabled={disabled}
      onClick={() => handleCheckout(amount, fileId)}
      className="w-full bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 ease-in-out disabled:bg-gray-400 disabled:cursor-not-allowed"
    >
      {isTemporary 
        ? `Zaplatit ${amount} Kč`
        : `Koupit kredity za ${amount} Kč`}
    </button>
  );
};

export default CheckoutButton;